import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth header interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Captcha
export const generateCaptcha = () => api.get('/captcha/generate');

// Applications
export const submitCourierApplication = (data) => api.post('/applications/courier', data);
export const submitRestaurantApplication = (data) => api.post('/applications/restaurant', data);
export const submitCompanyApplication = (data) => api.post('/applications/company', data);

export const getCourierApplications = () => api.get('/applications/courier');
export const getRestaurantApplications = () => api.get('/applications/restaurant');
export const getCompanyApplications = () => api.get('/applications/company');

export const updateCourierStatus = (id, status, note) => api.patch(`/applications/courier/${id}/status`, { status, note });
export const updateRestaurantStatus = (id, status, note) => api.patch(`/applications/restaurant/${id}/status`, { status, note });
export const updateCompanyStatus = (id, status, note) => api.patch(`/applications/company/${id}/status`, { status, note });

export const deleteCourierApplication = (id) => api.delete(`/applications/courier/${id}`);
export const deleteRestaurantApplication = (id) => api.delete(`/applications/restaurant/${id}`);
export const deleteCompanyApplication = (id) => api.delete(`/applications/company/${id}`);

// Integrations
export const getIntegrations = (audience) => {
  const params = audience ? { audience } : {};
  return api.get('/integrations', { params });
};
export const createIntegration = (data) => api.post('/integrations', data);
export const updateIntegration = (id, data) => api.patch(`/integrations/${id}`, data);
export const deleteIntegration = (id) => api.delete(`/integrations/${id}`);
export const reorderIntegrations = (ids) => api.post('/integrations/reorder', { ids });

// References
export const getReferences = (audience) => {
  const params = audience ? { audience } : {};
  return api.get('/references', { params });
};
export const createReference = (data) => api.post('/references', data);
export const updateReference = (id, data) => api.patch(`/references/${id}`, data);
export const deleteReference = (id) => api.delete(`/references/${id}`);
export const reorderReferences = (ids) => api.post('/references/reorder', { ids });

// Settings
export const getSEOSettings = () => api.get('/settings/seo');
export const updateSEOSettings = (data) => api.patch('/settings/seo', data);

export const getEmailSettings = () => api.get('/settings/email');
export const updateEmailSettings = (data) => api.patch('/settings/email', data);
export const testEmailSettings = () => api.post('/settings/email/test');

export const getSMSSettings = () => api.get('/settings/sms');
export const updateSMSSettings = (data) => api.patch('/settings/sms', data);

export const getContactSettings = () => api.get('/settings/contact');
export const updateContactSettings = (data) => api.patch('/settings/contact', data);

export const getGeneralSettings = () => api.get('/settings/general');
export const updateGeneralSettings = (data) => api.patch('/settings/general', data);

// Status Settings
export const getStatusSettings = (appType) => api.get(`/settings/statuses/${appType}`);
export const updateStatusSettings = (appType, data) => api.patch(`/settings/statuses/${appType}`, data);

// File Upload
export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const getFileUrl = (fileId) => {
  const baseUrl = api.defaults.baseURL || '';
  return `${baseUrl}/files/${fileId}`;
};

// Dashboard
export const getDashboardStats = () => api.get('/admin/stats');

// Admin User Management
export const getCurrentAdmin = () => api.get('/admin/me');
export const getAdminUsers = () => api.get('/admin/users');
export const createAdminUser = (data) => api.post('/admin/users', data);
export const updateAdminUser = (id, data) => api.patch(`/admin/users/${id}`, data);
export const deleteAdminUser = (id) => api.delete(`/admin/users/${id}`);

// AgrosJet.app Integration Settings
export const getAppIntegrationSettings = () => api.get('/settings/app-integration');
export const updateAppIntegrationSettings = (data) => api.patch('/settings/app-integration', data);
export const generateAppApiKey = () => api.post('/settings/app-integration/generate-key');
export const testAppWebhook = () => api.post('/settings/app-integration/test-webhook');

export default api;
